<div class="formfield nes-flex" id="bca-choose-image">
  <div class="formfield__content-container">

    <nes-heading tag="h2" size="md" class="nes-mb-2">
      {{ "USER_DATA.INPUT.PHOTO.LABEL" | translate }}
    </nes-heading>
    <nes-text size="md" color="blue" class="nes-mb-2">
      {{ "USER_DATA.INPUT.PHOTO.UPLOAD" | translate }}
    </nes-text>
    
    <ng-container *ngIf="selectedFaceImage as image; else default">
      <div class="image-container nes-mb-3" privacySensitive>
        <img class="animated pulse" [src]="image.imageAsBase64 | displayImage" />
      </div>
      <nes-button variant="primary">
        <a class="link" [cypress]="'delete_image'" (click)="delete.emit()">
          {{ "BUTTON.DELETE" | translate }}
        </a>
      </nes-button>
    </ng-container>
    <ng-template #default>
      <nes-button
      nes-id="open_upload_photo_dialog"
      id="open_upload_photo_dialog"
      (click)="openDialog.emit()"
      [cypress]="'choose_image'"
      type="button"
      >
      {{ "USER_DATA.BUTTON.CHOOSE_PHOTO" | translate }}
    </nes-button>
    <div *ngIf="imageRequiredError">
      <ng-container>
        <nes-error-message>
          {{ "USER_DATA.INPUT.PHOTO.ERROR_REQUIRED" | translate }}
        </nes-error-message>
      </ng-container>
    </div>
</ng-template>
</div>
</div>

